export enum AppMutationsEnum {
    STORE_IS_DARK = 'storeIsDark',
    STORE_POLLING = 'storePolling',
    STORE_TOTAL_LINKS = 'storeTotalLinks',
    STORE_CLICK_STATS = 'storeClickStats',
    STORE_MAPPED_LINKS = 'storeMappedLinks',
    STORE_APP_LOADING_STATE = 'storeAppLoadingState',
    STORE_NOTIFICATION_DATA = 'storeNotificationData',
}
